// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import scrubSiteSummary from './scrubSiteSummary'
import scrubPassiveData from './scrubPassiveData'
import { castToString } from 'helpers/reduxFormFunctions'

// returns the specified site
const getSite = (path, siteIndexes) => (
  path.segments[siteIndexes[0]].segmentEnds[siteIndexes[1]]
)

const scrubPathSummary = (d, index, unitType) => {
  // gets the indexes for the path ends
  // eg [{index in segments}, {index in segmentEnds}]
  const indexS1 = [0, 0]
  const indexS2 = [d.segments.length - 1, 1]

  const {
    band,
    bandId,
    pathId,
    pathName,
    projectName,
    projectId,
  } = d

  const pathIndex = (
    index !== null
      ? index + 1
      : null
  )

  // an array of simplified passive sites
  const passiveSummary = scrubPassiveData(d)
  const rcn = d.rcnNumber

  const rcnNumber = (
    rcn
      ? `RCN: ${castToString(rcn)}`
      : ''
  )

  // path ends data from API
  const rawSite1 = getSite(d, indexS1)
  const rawSite2 = getSite(d, indexS2)

  // scrubbed sites data (path ends)
  const site1 = scrubSiteSummary(rawSite1, unitType)
  const site2 = scrubSiteSummary(rawSite2, unitType)

  return {
    band,
    bandId,
    site1,
    site2,
    passiveSummary,
    pathId,
    pathIndex,
    pathName,
    projectId,
    projectName,
    rcn,
    rcnNumber,
    uniqueId: 'pathId',
  }
}

export default scrubPathSummary
